var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.642822,
    width: 49.7143,
    height: 49.7143,
    rx: 13.8095,
    fill: "#AB54A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_8285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0671 18.5823C11.4085 18.8874 11.7011 19.1441 11.9888 19.4057C15.5194 22.6121 19.0501 25.8186 22.5856 29.0201C23.7902 30.1148 25.2434 30.1099 26.4577 29.0105C30.1687 25.649 33.875 22.2828 37.5861 18.9165C37.6885 18.8245 37.7957 18.7373 37.9469 18.6065C37.9615 18.7712 37.9762 18.8923 37.9762 19.0085C37.9762 23.8714 37.9762 28.7392 37.9762 33.6021C37.9762 34.6338 37.4495 35.1618 36.4254 35.1618C28.4619 35.1618 20.5033 35.1618 12.5398 35.1618C11.6182 35.1618 11.0525 34.6145 11.0525 33.7039C11.0476 28.7731 11.0476 23.8375 11.0476 18.902C11.0476 18.8245 11.0574 18.747 11.0671 18.5823Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5167 27.1647C20.6154 23.6241 16.7336 20.1028 12.7885 16.5234H36.2351C32.3046 20.0931 28.4228 23.6193 24.5167 27.1647Z",
    fill: "#096784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_8285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9286,
    height: 18.6429,
    fill: "white",
    transform: "translate(11.0476 16.5234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.3b711f3d16a379f999ec53993c7594c7.svg";
export { ForwardRef as ReactComponent };